import type { FaireProductEntity } from "../../entity_types/product";

export const p_n2dj3esdur: FaireProductEntity = {
  token: "p_n2dj3esdur",
  type: "product",
  name: "Botany Porcelain Plant Pot Small",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/6c438178e992e557daaf3324b4df56913c8c01e31cebbff93c50749b3d775427.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c6827fa5936da4d267a37eea1df0abe31763deacf0aee7fb20d9f9de3f1ad4e7.jpeg",
    "https://cdn.faire.com/fastly/a785162ac40a797fccba8857ac2a2a4131837babf2edb7ce44c75f42e343eff8.jpeg",
    "https://cdn.faire.com/fastly/90caafbaf8b8b5f61459598a9845c8b0470b1fa6e9bc102d901a88deb73c7991.jpeg",
    "https://cdn.faire.com/fastly/af3a039cb1625316169d381afed38bc5c9392e4933ecdfb5642cbcbfdc8a6eed.jpeg",
    "https://cdn.faire.com/fastly/eef16c6efacbafb95a2cc36bcd3eeae31324c9a6c97dfa36ab4a00b7c680ad2e.jpeg",
    "https://cdn.faire.com/fastly/45727cdc4f05622750175f8c42628dc01358be2609cb9c3eda4fbbf4a8c12eb8.jpeg",
    "https://cdn.faire.com/fastly/6c0b2b960f43e4346da6a9d4dd3756c3274419e2062b167baa0941b273a7f2d3.jpeg",
    "https://cdn.faire.com/fastly/dbe6fb8ff798d299b0dc9b2a0f8781134790ca5794d67aaf6ef07ed60780fc6c.jpeg",
    "https://cdn.faire.com/fastly/bcd35d4c1fb5c2f6c61a951287bedcb36221dc4da5503b929c3c4885813b1ed3.jpeg",
    "https://cdn.faire.com/fastly/98bd7cfafdba77faaa5d59a6e04a3b3f229a82fb8a5aac73ac16941039672452.jpeg",
    "https://cdn.faire.com/fastly/d56270d994e1b1fe766ab082fdb083e1f40977a8029cb5b9c5819a8ae657e4f6.jpeg",
    "https://cdn.faire.com/fastly/e6a163f83c5a15aa9badde2b8fe478d121d12a9e42291a938968993d8e164cde.jpeg",
    "https://cdn.faire.com/fastly/8bcbe80b24379713fb4120b4715ade5ec590c232ec709bd0f76f11bb69eab52b.jpeg",
    "https://cdn.faire.com/fastly/f2f89c64535a0559977011c1c1f8ed0b86c18565cc4b63257eb98a3e33ed28b6.jpeg",
  ],
  priceDollars: 17.5,
  description:
    "Expertly hand-crafted in Sri Lanka using raw coloured porcelain clay. This minimalist plant pot has a soft form and a pleasing hand feel designed to elevate your greenery of choice. Whilst desirable on its own, this pot thrives when placed together with other members of the Botany family.\n\nThis pot is the perfect size for arranging small cacti and succulents on your desk or window sill.\n\nPlease note that due to the nature of the material, colour variation may occur.\nOur photos should be used as a guide.\n\nSize: Height 9cm, Diameter 11.5cm\n\nMaterial: Porcelain, Rubber (plug)\n\nPorcelain is one of the strongest ceramics and it ages beautifully. The material’s low porosity means it won’t leak onto your table or floor, and can confidently withstand all outdoor weather conditions.",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:26.707Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
